import { ceffuLogo } from "assets";
import { Container } from "components";
import React from "react";

function CeffuSection() {
  return (
    <section className="relative py-[40px] laptop:py-[90px] ceffuSection">
      <Container>
        <div className="max-w-[1000px] mx-auto text-center">
          <img
            src={process.env.REACT_APP_S3_IMAGES_URL + "ceffu-white.webp"}
            alt="ceffu"
            className="max-w-[150px] md:max-w-[200px] laptop:max-w-[380px] mx-auto mb-5 laptop:mb-10"
          />
          <h2 className="text-white text-xxl md:text-1xl laptop:text-2xl leading-8 md:leading-10 laptop:leading-[48px] laptop:-tracking-21 font-semibold mb-2">
            Secured By <span className="text-green uppercase">Ceffu</span>
          </h2>
          <p className="text-sm md:text-base font-normal leading-6 md:leading-[30px] -tracking-09 text-dim/80">
            Ceffu, the institutional-grade custody platform secures the vaults
            of Vanar Launchpool. This ensures top-tier security for
            institutional and individuals clients to safely store and manage
            their digital assets.  Ceffu provides a secure gateway to a wide
            range of liquidity products within the Binance ecosystem as
            Binance’s institutional custody partner.
          </p>
        </div>
      </Container>
    </section>
  );
}

export default CeffuSection;
